import API from 'services/api';

import { IMailDetails } from '../models/IMailDetails';

export const getDocumentMail = (mailId: string): Promise<IMailDetails> =>
  API.get(`/api/docs/emails/${mailId}`).then(response => response?.data);
